class ObstetricalResourcesAnxietyScreening {
    public AnxietyScreeningDate?: Date;
    public NervousScore?: number;
    public WorryScore?: number;

    constructor(fields?: Partial<ObstetricalResourcesAnxietyScreening>) {
        Object.assign(this, fields);
    }

    public get TotalScore(): number {
        if (this.NervousScore == null && this.WorryScore == null)
            return null;

        return (this.NervousScore ?? 0) + (this.WorryScore ?? 0);
    }
}

export { ObstetricalResourcesAnxietyScreening };
